export const EMPTY_STATES = {
  NO_RESULTS: {
    title: 'Nada por aqui ainda',
    subtitle: 'Que tal tentar outra busca ou conferir os eventos disponíveis?'
  },
  OTHER_CITY: {
    title: 'Nenhum resultado em',
    subtitle: 'Mas encontramos opções em outras cidades para você.'
  },
  WITH_FILTERS: {
    title: 'Nenhum resultado encontrado',
    subtitle: 'Tente ajustar os filtros ou explore outras modalidades e datas.'
  }
};
